"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _ossUpload = require("@/utils/ossUpload");
var _appBasicSetup = require("@/api/appBasicSetup");
var _basePagePop = _interopRequireDefault(require("./components/basePagePop.vue"));
var _router = _interopRequireDefault(require("@/router"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    basePagePop: _basePagePop.default
  },
  data: function data() {
    // var validateFile = (rule, value, callback) => {
    //   if (value.length === 0) {
    //     callback(new Error('请上传文件'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      domainList: '',
      activeName: '1',
      templateList: [],
      userCenterList: [],
      ruleForm: {
        hotkeyStatus: 0,
        name: '',
        mainColor: '',
        mainFontColor: '',
        salveColor: '',
        salveFontColor: '',
        icon: '',
        preloadedImage: '',
        topIcon: '',
        pageCode: '',
        personalPageCode: '',
        // appLoginBackgroundImage: '',
        // appDescription: '',
        license: process.env.VUE_APP_H5_HOST + '/pages/basePage/license?appNo=' + sessionStorage.getItem('appNo'),
        privacy: process.env.VUE_APP_H5_HOST + '/pages/basePage/privacy?appNo=' + sessionStorage.getItem('appNo'),
        searchText: '',
        // guideMaps: [],
        downloadLink: ''
      },
      rules: {
        // guideMaps: [
        //   { required: true, message: '请上传文件引导图', validator: validateFile, trigger: 'change' }
        // ],
        searchText: [{
          required: false,
          message: '请填写搜索框文字',
          trigger: 'blur'
        }],
        license: [{
          required: true,
          message: '请填写用户协议',
          trigger: 'blur'
        }],
        // appDescription: [
        //   { required: true, message: '请填写app描述', trigger: 'blur' }
        // ],
        privacy: [{
          required: true,
          message: '请填写用隐私政策',
          trigger: 'blur'
        }],
        icon: [{
          required: true,
          message: '请上传app图标',
          trigger: 'change'
        }],
        preloadedImage: [{
          required: true,
          message: '请上传app引导图',
          trigger: 'change'
        }]
        // appLoginBackgroundImage: [
        //   { required: true, message: '请上传app登录页背景图', trigger: 'change' }
        // ]
      }
    };
  },
  watch: {
    activeName: function activeName(val) {
      if (val === '1') {
        this.getAppDetail();
      } else if (val === '2') {
        this.queryList();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.getAppDetail();
    this.queryHomepageTemplateSelect();
    (0, _appBasicSetup.queryHomepageTemplateSelect)({
      pageType: 2
    }).then(function (res) {
      _this.userCenterList = res.data || [];
    });
  },
  methods: {
    openGoodsList: function openGoodsList(val) {
      _router.default.push({
        path: "/appNewRenovation/".concat(val, "/index")
      });
    },
    getAppDetail: function getAppDetail() {
      var _this2 = this;
      (0, _appBasicSetup.queryAppDetail)().then(function (res) {
        if (res.data) {
          res.data.guideMaps = res.data.guideMaps === null ? [] : res.data.guideMaps;
          res.data.license = process.env.VUE_APP_H5_HOST + '/pages/basePage/license?appNo=' + sessionStorage.getItem('appNo');
          res.data.privacy = process.env.VUE_APP_H5_HOST + '/pages/basePage/privacy?appNo=' + sessionStorage.getItem('appNo');
          _this2.ruleForm = (0, _objectSpread2.default)({}, res.data);
          delete _this2.ruleForm.agent;
          delete _this2.ruleForm.inviteConfig;
        }
      });
    },
    queryList: function queryList() {
      var _this3 = this;
      (0, _appBasicSetup.queryWhiteList)().then(function (res) {
        _this3.domainList = res.data.replaceAll(';', '\n');
      });
    },
    queryHomepageTemplateSelect: function queryHomepageTemplateSelect() {
      var _this4 = this;
      (0, _appBasicSetup.queryHomepageTemplateSelect)().then(function (res) {
        _this4.templateList = res.data || [];
      });
    },
    handleClick: function handleClick() {},
    setList: function setList() {
      var _this5 = this;
      this.$confirm('是否确认保存内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _appBasicSetup.setWhiteList)({
          urlList: _this5.domainList.replaceAll('\n', ';')
        }).then(function (res) {
          _this5.$notify.success({
            title: '温馨提示',
            message: '保存成功！'
          });
          _this5.queryList();
        });
      });
    },
    bothBuff: function bothBuff(val) {
      var _this6 = this;
      console.log(process.env);
      (0, _appBasicSetup.queryLicenseAndPrivacy)({
        key: val.key
      }).then(function (res) {
        _this6.$refs.basePagePop.open({
          name: val.title,
          text: res.data.value,
          key: val.key
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this7 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this7.$confirm('当前页配置信息发生修改,是否确认修改内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _appBasicSetup.appUpdateTenant)(_this7.ruleForm).then(function (res) {
              _this7.$notify.success({
                title: '温馨提示',
                message: '保存成功！'
              });
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm[val] = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleRemove: function handleRemove(file) {
      var sp_index = '';
      this.ruleForm.guideMaps.map(function (i, index) {
        if (i.url === file.url) {
          sp_index = index;
        }
      });
      this.ruleForm.guideMaps.splice(sp_index, 1);
    },
    handleFileUpload_guideMaps: function () {
      var _handleFileUpload_guideMaps = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref2) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref2.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.guideMaps.push({
                url: pictureUrl
              });
              this.$refs.ruleForm11.validateField('guideMaps');
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload_guideMaps(_x3) {
        return _handleFileUpload_guideMaps.apply(this, arguments);
      }
      return handleFileUpload_guideMaps;
    }()
  }
};